import Client from '../../utils/ClientVOIM';
import { ACTION_TYPES } from '../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../utils/ResponseConstant';
import URL from '../../utils/URL';
import { myLog } from '../../utils/Utility';

export const activeInstitution = (values, callBack) => {
    return function (dispatch) {
        Client.put(URL.INS_SUPER_ADMIN.ACTIVE_INSTITUTION, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.INSTITUTION_LIST,
                        payload: response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export function adminNotification(values, callBack) {
    return function (dispatch) {
        Client.get(URL.SUPER_ADMIN.ADMIN_NOTIFICATION, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
}

export function notificationCount(callBack) {
    return function (dispatch) {
        Client.get(URL.SUPER_ADMIN.NOTIFICATION_COUNT, null, true)
            .then((response) => {
                callBack(response);
                dispatch({
                    type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                    payload: response.response.unread,
                });
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}

export function markAllAsRead(params, callBack) {
    return function (dispatch) {
        Client.put(
            `${URL.SUPER_ADMIN.MARK_AS_READ}?id=${params.id}&userId=${params.userId}`,
            null,
            true
        )
            .then((response) => {
                callBack(response);
                dispatch({
                    type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                    payload: 0,
                });
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}

export const verifyUser = (id, callBack) => {
    return function (dispatch) {
        Client.put(URL.SUPER_ADMIN.VERIFY_USER + id, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====VERIFY_USER error===????', error);
                callBack(false);
            });
    };
};

export function userVerify(values, callBack) {
    return function (dispatch) {
        Client.put(URL.INS_SUPER_ADMIN.USER_VERIFY, values, true)
            .then((response) => {
                myLog('====addGrade response===::::', response);
                callBack(response);
                dispatch({
                    type: ACTION_TYPES.INS_SUPER_ADMIN.USER_VERIFY,
                    payload: response,
                });
            })
            .catch((error) => {
                myLog('====addGrade error===????', error);
                callBack(false);
            });
    };
}

export function rejectTutor(values, callBack) {
    return function (dispatch) {
        Client.put(URL.SUPER_ADMIN.REJECT_TUTOR, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.REJECT_TUTOR,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
}

export const getUserDetails = (userId, callBack) => {
    return function (dispatch) {
        const values = { isEnrollmentNeeded: true };
        Client.get(URL.SUPER_ADMIN.USERDETAILS + userId, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====VERIFY_USER error===????', error);
                callBack(false);
            });
    };
};

export function getSystemFeature(callBack) {
    return function (dispatch) {
        Client.get(URL.SUPER_ADMIN.SYSTEM_FEATURE, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}
